import { Stack } from "@mantine/core";
import { SiteLicense } from "../../../../types/api.types";
import type {
  Site,
  SiteCategoriesResponse
} from "../../../../utils/backend-types";
import { isPremiumSite } from "../../../../utils/isPremiumSite";
import type { SiteSetupProcess } from "../../hooks/useSiteSetupProcesses";
import { SetupProcessItem } from "../SetupProcessItem/SetupProcessItem";
import { SiteItem } from "../SiteItem/SiteItem";

interface SitesListProps {
  projectId: string;
  sites: ReadonlyArray<Site>;
  setupProcesses: ReadonlyArray<SiteSetupProcess>;
  siteCategories?: ReadonlyArray<SiteCategoriesResponse>;
  highlightTerm: string;
  onClickEdit: (site: Site) => void;
  onDelete: (site: Site | SiteSetupProcess) => void;
}

function SitesList({
  projectId,
  sites,
  setupProcesses,
  siteCategories,
  highlightTerm,
  onClickEdit,
  onDelete
}: SitesListProps) {
  return (
    <Stack align="stretch" gap="xs">
      {sites.map((site) => (
        <SiteItem
          highlightTerm={highlightTerm}
          isLight={
            siteCategories?.find(
              (categoriesPerSite) => categoriesPerSite.id === site.id
            )?.license === SiteLicense.light
          }
          isPremium={isPremiumSite(siteCategories, site.id)}
          key={site.id}
          projectId={projectId}
          showLicense={siteCategories?.some(
            (category) => category.is_partial_feedin_site
          )}
          site={site}
          onClickEdit={() => onClickEdit(site)}
          onDelete={() => onDelete(site)}
        />
      ))}
      {setupProcesses.map((setupProcess) => (
        <SetupProcessItem
          highlightTerm={highlightTerm}
          key={setupProcess.id}
          projectId={projectId}
          setupProcess={setupProcess}
          onDelete={onDelete}
        />
      ))}
    </Stack>
  );
}

export { SitesList, SitesListProps };
